import { useLocation } from "react-router-dom";

export function useAddCustomerSearchParams() {
	const location = useLocation();
	const searchParams = new URLSearchParams(location.search);
	const abn = searchParams.get('ABN');
	const acn = searchParams.get('ACN');
	return {
		abn: abn,
		acn: acn
	};
}